import { lazy } from 'react';

export default [
    {
        path: '/scaled-map',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'ScaledMapLayout' */ './layout')),
    },
];
